export default __webpack_public_path__ + "static/media/e-commerce.211b3634.webp";